import { Component } from '@angular/core';
import { Region } from 'src/app/core/models/classes/region';
import { Customer } from 'src/app/core/models/classes/owner';
import { MatDialogRef } from '@angular/material/dialog';
import { RegionService } from '../../../core/services/region.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-advancedcache',
  templateUrl: './advancedcache.component.html',
  styleUrls: ['./advancedcache.component.scss']
})
export class AdvancedcacheComponent {
regions: Region[] = [];
allOptions: string[] = [];
customers: Customer[] = [];
isOptionsEnabled: boolean = false;
isSelectionEnabled: boolean = false;
chosenRegion: string = "";
selectedOwners: string[];
criteriaHeader: string = "";

constructor(  
    private regionService: RegionService,    
    private _snackBar: MatSnackBar,
    public dialog: MatDialogRef<AdvancedcacheComponent>
  ){}

ngOnInit(): void {
  this.regionService.getRegions().subscribe({
    next: (reg) => {
      this.regions = reg;            
    },
    error: (err) => {throw Error(err.Status)},
  });

  this.regionService.getCustomers().subscribe({
    next: (data) => {
      this.customers = data;              
    },
    error: (err) => {throw Error(err.Status)},
  });

  this.allOptions = [$localize`Customer`];
}

selectCriteria(option: any){
  if(option.includes($localize`Customer`)){
    this.criteriaHeader = $localize`Select customers:`;
  }
  
  this.isSelectionEnabled = true;
}

selectRegion(reg: string){
  this.chosenRegion = reg;
}

onSave(){
  this._snackBar.open($localize `Cache settings saved successfully`, '', {
    duration: 3000
  });
  this.dialog.close();
}
}